export const PASSWORD_POLICY = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
};

export const validatePassword = (password: string): string | null => {
    if (password.length < PASSWORD_POLICY.minLength) {
        return "users.password_min_length";
    }

    const lowerCount = (password.match(/[a-z]/g) || []).length;
    if (lowerCount < PASSWORD_POLICY.minLowercase) {
        return "users.password_min_lowercase";
    }

    const upperCount = (password.match(/[A-Z]/g) || []).length;
    if (upperCount < PASSWORD_POLICY.minUppercase) {
        return "users.password_min_uppercase";
    }

    const numCount = (password.match(/[0-9]/g) || []).length;
    if (numCount < PASSWORD_POLICY.minNumbers) {
        return "users.password_min_numbers";
    }

    const symCount = (password.match(/[\W_]/g) || []).length;
    if (symCount < PASSWORD_POLICY.minSymbols) {
        return "users.password_min_symbols";
    }

    return null;
};
